import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-patient-message',
  templateUrl: './patient-message.component.html',
  styleUrls: ['./patient-message.component.css']
})
export class PatientMessageComponent implements OnDestroy, OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(authService.authenticatedUser.value.locale || 'en');
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.authService.logout();
  }

  handleLinkClick(): void {
    this.authService.logout();
  }
}